import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import styles from './TableBodyRow.module.scss';

const EXTRA_ROW_CLASS = 'ant-table-expanded-row ant-table-expanded-row-level-1';
const EXTRA_ROW_KEY_SUFFIX = 'extra-row';
const SELECTION_CELL_CLASS = 'ant-table-selection-column';

const extraRowPropsType = {
  expandedRowRender: 'function',
  colCount: 'number',
  hasEmptyCell: 'boolean',
  record: 'object',
};

const hasAllExtraRowKeys = (extraRowProps) =>
  extraRowProps
    ? Object.entries(extraRowPropsType).every(([propKey, propValue]) => {
        const value = extraRowProps[propKey];

        if (propKey === 'record') {
          return value && typeof value === 'object' && !Array.isArray(value);
        }

        return value && typeof value === propValue;
      })
    : false;

const TableBodyRow = ({
  isClickable = false,
  isExpanded = false,
  children,
  className,
  extraRowProps,
  ...props
}) => {
  const [showExtraRow, setShowExtraRow] = useState(false);

  const { expandedRowRender, colCount, hasEmptyCell, record } =
    extraRowProps || {};

  useEffect(() => {
    setShowExtraRow(hasAllExtraRowKeys(extraRowProps) && isExpanded);
  }, [extraRowProps, isExpanded]);

  return (
    <>
      <tr className={styles.tableInvisibleBodyRow} />
      <tr
        {...props}
        className={cn(styles.tableBodyRow, className, {
          [styles.tableBodyRowClickable]: isClickable,
          [styles.tableBodyRowExpanded]: isExpanded,
        })}
      >
        {children}
      </tr>
      {showExtraRow && (
        <tr
          className={EXTRA_ROW_CLASS}
          data-row-key={`${props['data-row-key']}-${EXTRA_ROW_KEY_SUFFIX}`}
        >
          {hasEmptyCell && <td className={SELECTION_CELL_CLASS} colSpan={1} />}
          <td colSpan={colCount}>{expandedRowRender(record)}</td>
        </tr>
      )}
    </>
  );
};

export default TableBodyRow;
